import {
  DISPLAY_GO_HOME
} from './constants';

const initialState = { 
  displayGoHome: false
};

export const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case DISPLAY_GO_HOME:{
      return {
        ...state,
        displayGoHome: payload
      };
    } 
    default:
      return state;
  }
};
 
export default reducer;



// WEBPACK FOOTER //
// ./src/features/registration/accountCreated/reducer.js